<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import DataTable from "@/components/DataTable.vue";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Reconciliation Reports",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
    ModelListSelect,
  },
  data() {
    return {
      title: "Stock Reconciliation Reports",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Reconciliation Reports",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [2,10, 25, 50, 100, 200, 1000],
      IsReconcilationsServerPaginated: true,
      filter: null,
      serverPerPage: 2,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "Product",
        },
        {
          key: "from",
          sortable: true,
          label: "FROM",
        },
        {
          key: "to",
          sortable: true,
          label: "To",
        },
        {
          key: "date",
          sortable: true,
          label: "Date Performed",
        },
        {
          key: "agent",
          sortable: true,
          label: "Agent",
        },
        {
          key: "user",
          sortable: true,
          label: "Performed By",
        },
      ],
      filterReconciliation: {
        agent_id: 0,
        product_id: 0,
        date_from: moment().subtract(1, "months").format("YYYY-MM-DD"),
        date_to: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 2,
      },
    };
  },
  computed: {
    ...mapGetters("agentstock", [
      "Reconcilations",
      "ReconcilationsPagination",
      "ReconcilationsPaginated",
      "FilterStatus",
    ]),
    ...mapGetters("products", ["Products"]),

    rows() {
      return this.IsReconcilationsServerPaginated
        ? (this.ReconcilationsPagination &&
            this.ReconcilationsPagination.total) ||
            0
        : this.Reconcilations
        ? this.Reconcilations.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsReconcilationsServerPaginated) {
          return (
            (this.ReconcilationsPagination &&
              this.ReconcilationsPagination.per_page) ||
            this.filterReconciliation.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsReconcilationsServerPaginated) {
          this.filterReconciliation.per_page = value;
          this.filterReconciliation.page = 1;
          this.FetchReports(this.filterReconciliation);
        }
      },
    },

    currentPage: {
      get() {
        return this.ReconcilationsPaginated && this.ReconcilationsPagination
          ? this.ReconcilationsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ReconcilationsPaginated) {
          this.filterReconciliation.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  methods: {
    ...mapActions({
      FetchReports: "agentstock/fetchReconcilations",
      FetchItems: "products/fetchProducts",
    }),

    redirect(value) {
      this.$router.push(`/reconciliation/details/${btoa(value)}`);
    },

    handlePageChange(newPage) {
      if (this.IsReconcilationsServerPaginated) {
        this.filterReconciliation.page = newPage;
        this.FetchReports(this.filterReconciliation);
      }
    },

    FilterReconciliationRepoort() {
      this.filterReconciliation.page = 1;
      this.FetchReports(this.filterReconciliation);
    },
  },

  created() {
    this.FetchReports(this.filterReconciliation);
    this.FetchItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="row">
                <div class="col-sm-6 col-md-2 d-flex align-items-end">
                <div class="form-group mb-0 w-100">
                  <label class="mb-0">From</label>
                  <input
                    type="date"
                    v-model="filterReconciliation.date_from"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-sm-6 col-md-3 d-flex align-items-end">
                <div class="form-group mb-0 w-100">
                  <label class="mb-0">To</label>
                  <input
                    type="date"
                    v-model="filterReconciliation.date_to"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-sm-12 col-md-4">
                <label>SEARCH FOR PRODUCT</label>

                <model-list-select
                  :list="
                    Products
                      ? [{ id: 0, name: 'All Products' }, ...Products]
                      : [{ id: 0, name: 'All Products' }]
                  "
                  v-model="filterReconciliation.product_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select product"
                  @input="FilterReconciliationRepoort()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="FilterReconciliationRepoort()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
              </div>
              <div class="col-sm-12 col-md-3 d-flex align-items-end mt-3">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-2">
              <DataTable
                class="datatables"
                :columns="fields"
                responsive="sm"
                :rows="Reconcilations || []"
                :total-rows="rows"
                :pagination="ReconcilationsPagination"
                :server-pagination="IsReconcilationsServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(product)="{ row }">
                  {{ row.product }}
                </template>

                <template #cell(from)="{ row }">
                  {{ row.from }}
                </template>
                <template #cell(to)="{ row }">
                  {{ row.to }}
                </template>
                <template #cell(date)="{ row }">
                  {{ row.date }}
                </template>
                <template #cell(agent)="{ row }">
                  {{ row.agent }}
                </template>
                <template #cell(user)="{ row }">
                  {{ row.user }}
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
